import type { TypePolicies } from "@apollo/client";

import type { JobCardDataFragment } from "./graphQL/fragments/__generated__/jobCardData.gqlgenerated";

export const jobCardDataLocalTypePolicies = {
  Job: {
    keyFields: ["key"],
    fields: {
      // handle local-only fields
      viewJobLink: {
        read(existing: JobCardDataFragment["viewJobLink"]) {
          return existing ?? null;
        },
      },
      featuredCardData: {
        read(existing: JobCardDataFragment["featuredCardData"]) {
          return existing ?? null;
        },
      },
      sponsoredDisclaimer: {
        read(existing: JobCardDataFragment["sponsoredDisclaimer"]) {
          return existing ?? null;
        },
      },
    },
  },
} satisfies TypePolicies;
